module.exports = __webpack_public_path__ + "static/media/landingPage.12a30a8f.png";